import React from 'react';
import LinkIcon from '@material-ui/icons/Link';
import ListItemLink, { NavigationLink } from './ListItemLink';

const NavLinks: React.SFC = () => {

  // TODO: based off of subscription, choose which links to show
  const availableLinks = [
    {label: 'Links', icon: <LinkIcon />,  to: '/links'},
  ];

  return (
    <>
      {availableLinks.map((link: NavigationLink, idx: number) => (
        <ListItemLink key={idx} {...link} />
      ))}
    </>
  );
}

export default NavLinks;
